import React from 'react';
import {Box, Card, CardContent, CardHeader, Divider, LinearProgress, Typography} from '@mui/material';
import {t} from 'ttag';
import {createDatetime, DATETIME_FORMAT_NO_SEC} from '../../../utils/datetime/datetime-utils';
import {DataGrid, GridSlotsComponent} from '@mui/x-data-grid';
import table from '../../../components/common/styles';
import {IClaimFlight} from '../../../store/apis/interfaces/claim';

type FlightsDetailsProps = {
  rows?: IClaimFlight[];
};

const columns = [
  {
    field: 'flightNumber',
    headerName: t`Flight Number`,
    sortable: true,
    disableColumnMenu: true,
    flex: 1,
    minWidth: 170,
    cellClassName: 'secondary-text',
    valueGetter: ({row}: any) => row?.flightNumber || 'N/A'
  },
  {
    field: 'flightDate',
    headerName: t`Date`,
    sortable: true,
    type: 'date',
    disableColumnMenu: true,
    flex: 1,
    minWidth: 140,
    valueGetter: ({row}: any) => new Date(row?.flightDate),
    renderCell: ({row}: any) => row?.flightDate ? createDatetime(row?.flightDate).toFormat(DATETIME_FORMAT_NO_SEC) : 'N/A'
  },
  {
    field: 'origin',
    headerName: t`Origin Airport`,
    sortable: true,
    disableColumnMenu: true,
    flex: 1,
    minWidth: 170,
    valueGetter: ({row}: any) => row?.origin || 'N/A'
  },
  {
    field: 'destination',
    headerName: t`Destination Airport`,
    sortable: true,
    disableColumnMenu: true,
    flex: 1,
    minWidth: 170,
    valueGetter: ({row}: any) => row?.destination || 'N/A'
  },
  {
    field: 'claimType',
    headerName: t`Type`,
    sortable: true,
    disableColumnMenu: true,
    minWidth: 190,
    flex: 1,
    valueGetter: ({row}: any) => row?.claimType?.name || 'N/A'
  },
  {
    field: 'claimSubType',
    headerName: t`Subtype`,
    sortable: true,
    disableColumnMenu: true,
    minWidth: 190,
    flex: 1,
    valueGetter: ({row}: any) => row?.claimSubType?.name || 'N/A'
  }
];

export const FlightsDetails = ({rows}: FlightsDetailsProps) => {

  return (
    <Card elevation={3}>
      <CardHeader title={<Typography sx={{fontFamily: 'OpenSansMedium'}}>{t`Flights Details`}</Typography>} />
      <Divider />
      <CardContent>
        <DataGrid
          hideFooter
          getRowId={(row) => row?.claimId}
          columns={columns}
          rows={rows || []}
          loading={Boolean(!rows)}
          autoHeight
          components={{
            noRowsOverlay: () => (
              <Box display={'flex'} height={'100%'} alignItems={'center'} justifyContent={'center'}>
                <Typography variant={'body2'}>{t`No flights found`}</Typography>
              </Box>
            ),
            loadingOverlay: () => (
              <LinearProgress sx={{
                backgroundColor: 'rgb(228,232,238)',
                height: 6,
                '& .MuiLinearProgress-bar1Indeterminate': {
                  backgroundColor: 'rgb(228,232,238)',
                },
                '& .MuiLinearProgress-bar2Indeterminate': {
                  backgroundColor: 'rgb(218,222,228)',
                }
              }}/>
            )
          } as Partial<GridSlotsComponent>}
          sx={{
            ...table,
            '& .MuiDataGrid-cell': {
              whiteSpace: 'normal !important'
            },
            '& .MuiDataGrid-columnHeaders': {
                ...table['& .MuiDataGrid-columnHeaders'],
                borderBottom: Boolean(!rows) ? '1px solid transparent' : '1px solid #0e2846'
            }
          }}
        />
      </CardContent>
    </Card>
  );
}

export default FlightsDetails;
